class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"]'),
      countryInput: this.querySelector('input[name="country_code"]'),
      buttons: this.querySelectorAll('button[type="switch"]'),
      list: this.querySelector('x-listbox'),
    }
    this.formId = this.getAttribute('form-id');
    this.form = document.querySelector('form#'+this.formId);
    this.elements.buttons.forEach((button) => button.addEventListener('click', this.onItemClick.bind(this)));
    document.body.addEventListener('click', this.onBodyClick.bind(this));
  }

  onItemClick(event) {
    event.preventDefault();
    const link = event.target.closest('a');
    const button = event.target.closest('button');
    const country = button.getAttribute('data-country');
    const language = button.getAttribute('data-language');
    if (country) {
      this.elements.countryInput.value = country;
    }
    if (language) {
      this.elements.input.value = language;
    }
    this.submit();
  }

  onBodyClick(event) {
    const isOption = this.contains(event.target);
  }

  submit() {
    this.form.submit();
  }
}

if (!window.customElements.get('localization-form')) {
  window.customElements.define('localization-form', LocalizationForm);
}
